// ** Custom Components
import { createIconComponent } from "./createIconComponent";

// #####################################################

/**
 * SolidEyeSlash Icon Component
 */
const SolidEyeIcon = createIconComponent("eye", "solid");

export default SolidEyeIcon;

// #####################################################
